import { FormAutoCompleteMultiSelectDynamic } from '../../components/hook-form/form-autocomplete-multi-select.dynamic.component';
import { FormSelectDynamic } from '../../components/hook-form/form-select.dynamic.component';
import { customersApiKeyStore } from '../../api/customers-api-key-store';
import { officeApiKeyStore } from '../../api/office-api-key-store';
import { projectsApiKeyStore } from '../../api/projects-api-key-store';
import { marketAreaApiKeyStore } from '../../api/masters/market-area-api-key-store';
import { usersApiKeyStore } from '../../api/users-api-key-store';
import { workOrdersApiKeyStore } from '../../api/workorders-api-key-store';
import {
  Badge,
  BadgeProps,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  styled,
  Tooltip,
  Typography,
  Button
} from '@mui/material';
import { SiTrackGrid } from '../../components/si-track-grid/si-track-grid';
import { workOrderColumns } from './workorders-grid-columns';
import { DateFormat, FormDateField } from '../../components/hook-form/form-date.field.component';
import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSaveData } from '../../hooks/useSaveData';
// import { Button } from '@mui/base';
import { FormAutoCompleteSelectDynamic } from '../../components/hook-form/form-autocomplete-select.dynamic.component';
import { divisionApiKeyStore } from '../../api/masters/division-api-key-store';
import ReportIcon from '@mui/icons-material/Report';
import { WorkOrder } from '../../models/workOrder';
import { UserPermissionName } from '../../models/user-permission-name';
import { Icons } from '../../assets/icons';
import moment from 'moment';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingIndicator } from '../../components/loading-indicator.component';
import { GridCellProps, GridRowProps } from '@progress/kendo-react-grid';
import React from 'react';
import dayjs from 'dayjs';
import { useLoadData } from '../../hooks/useLoadData';
import { ApiResponse } from '../../models/api-response';
import { GridColumnConfig, GridPreference } from '../../models/gridCoumnConfig';
import { gridApiKeyStore } from '../../api/grid-api-key-store';
import { State } from '@progress/kendo-data-query';
import useDebounce from '../../hooks/use-debounce';
import { useNavigate } from 'react-router-dom';
import { GuardedComponent } from '../../components/guarded-component';
import { useAuthorize } from '../../hooks/use-authorize';
import { departmentsApiKeyStore } from '../../api/masters/department-api-key-store';
import { holidayManagementApiKeyStore } from '../../api/masters/holiday-management-api-key-store';
import { useSnackbar } from '../../hooks/use-snackbar.hook';

const styling = {
  dialogTitleStyle: { padding: '16px 24px 0' },
  contentPadding: { paddingTop: '30px' },
  buttonPadding: { paddingTop: '20px' },
  tabHeading: { fontWeight: 'bold' },
  buttonStyle: { width: '130px' },
};
interface SelectWorkOrdersProps {
  selectedFilters: any; // Assuming selectedFilters is of type URLSearchParams
  selectedWorkorder: WorkOrder[];
  handleSelectedWorkOrder: (value: WorkOrder[]) => void;
  selectedInspector: any[];
}

interface ImperativeHandle {
  handleFilterAutoClick: () => void;
}

interface CellProps {
  workorderItem: any;
}

interface CustomGridCellProps {
  field: string;
}

export const SelectWorkOrders = forwardRef<ImperativeHandle, SelectWorkOrdersProps>((props, ref) => {
  const navigate = useNavigate();
  const { selectedFilters, selectedWorkorder, handleSelectedWorkOrder, selectedInspector } = props;
  const { watch, setValue, getValues } = useFormContext();
  const [customerID, setCustomerID] = useState<any>(selectedFilters.customer ?? '');
  const [workOrderStatusIDs, setWorkOrderStatusIDs] = useState<any>(selectedFilters.workOrderStatusID ?? '');
  const [officeIDs, setOfficeIDs] = useState<any[]>(selectedFilters.officeIDs ?? []);
  const [projectIDs, setProjectIDs] = useState<any[]>(selectedFilters.projectIDs ?? []);
  const [marketAreaIDs, setMarketAreaIDs] = useState<any[]>(selectedFilters.marketAreaIDs ?? []);
  const [divisionIDs, setDivisionIDs] = useState<any[]>(selectedFilters.divisions ?? []);
  const [userIDs, setUserIDs] = useState<any[]>(selectedFilters.userIDs ?? []);
  const [departments, setDepartments] = useState<any[]>(selectedFilters.departments ?? []);
  const [fromDate, toDate] = watch(['fromDate', 'toDate']);
  // const [selectedWorkorder, setSelectedWorkorder] = useState<WorkOrder[]>([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentWorkOrderID, setCurrentWorkOrderID] = useState(0);

  const { isLoading: isPrerequisitesLoading, mutateAsync: mutatePrerequisitesAsync } = useSaveData<any>(workOrdersApiKeyStore.checkPrerequisitesBeforeReady());

  const { isLoading, data, mutateAsync } = useSaveData<any>(workOrdersApiKeyStore.workOrderInspections());
  const {
    isLoading: isLoadingProposedSheduleDate,
    data: updatedProposeSheduleDateData,
    mutateAsync: updateProposedSheduleDate,
  } = useSaveData<any>(workOrdersApiKeyStore.updateProposedScheduleDate());

  useEffect(() => {
    if (
      customerID ||
      officeIDs.length > 0 ||
      projectIDs.length > 0 ||
      marketAreaIDs.length > 0 ||
      userIDs.length > 0 ||
      workOrderStatusIDs ||
      fromDate ||
      toDate ||
      divisionIDs.length > 0
    ) {
      mutateAsync({
        data: {
          customerID: selectedFilters.customer,
          offices: selectedFilters.officeIDs?.map((p: any) => p.officeID),
          projects: selectedFilters.projectIDs?.map((p: any) => p.projectID),
          marketAreas: marketAreaIDs?.map((p: any) => p.marketAreaID),
          inspectors: userIDs?.map((p: any) => p.userID),
          //workOrderStatus: workOrderStatusIDs?.map((p: any) => p.workOrderStatusID),
          workOrderStatusID: workOrderStatusIDs,
          scheduledDateFrom: fromDate,
          scheduledDateTo: toDate,
          divisions: divisionIDs?.map((p: any) => p.divisionID),
        },
      });
    }
  }, []);

  useEffect(() => {
    if (data?.data) {
      setValue('workOrders', []);
    }
  }, [data?.data]);

  const handleSelectedWorkOrders = (values: any[], isChecked?: boolean, removeValue?: any) => {
    if (removeValue) {
      setValue('workOrders', values);
      handleSelectedWorkOrder(values);
      return;
    }
    if (!isChecked) {
      setValue('workOrders', values);
      handleSelectedWorkOrder(values);
      return;
    }
    if (values.length === 0) {
      setValue('workOrders', []);
      handleSelectedWorkOrder([]);
      return;
    }
    setValue('workOrders', values);
    handleSelectedWorkOrder(values);
  };

  const handleFilterClick = () => {
    setValue('workOrders', []);
    handleSelectedWorkOrder([]);
    mutateAsync({
      data: {
        customerID: customerID,
        offices: officeIDs?.map((p: any) => p.officeID),
        projects: projectIDs?.map((p: any) => p.projectID),
        marketAreas: marketAreaIDs?.map((p: any) => p.marketAreaID),
        inspectors: userIDs?.map((p: any) => p.userID),
        // workOrderStatusID: workOrderStatusIDs?.map((p: any) => p.workOrderStatusID),
        workOrderStatusID: workOrderStatusIDs === 0 ? 2 : workOrderStatusIDs,
        scheduledDateFrom: fromDate,
        scheduledDateTo: toDate,
        divisions: divisionIDs?.map((p: any) => p.divisionID),
        departments: departments?.map((s: any) => s?.departmentID) ?? []
      },
    });
    handleSaveFilter();
  };

  useImperativeHandle(ref, () => ({
    handleFilterAutoClick: () => {
      handleFilterClick();
      // Filter logic here
    },
  }));

  const handleOnChange = (type: string, value: any) => {
    if (type === 'customer') {
      setCustomerID(value?.customerID);
      setValue('officeIDs', undefined);
      setValue('projectIDs', undefined);
      setProjectIDs([]);
      setOfficeIDs([]);
    }

    if (type === 'office') {
      setOfficeIDs(value);

      if (value?.length === 0) {
        setValue('projectIDs', undefined);
        setProjectIDs([]);
      } else {
        const selectedOfficeIDs = value.map((office: any) => office.officeID);
        const filteredProjects = getValues('projectIDs')?.filter((project: any) =>
          selectedOfficeIDs.includes(project.officeID)
        );
        setValue('projectIDs', filteredProjects);
        setProjectIDs(filteredProjects);
      }
    }

    if (type === 'project') {
      setProjectIDs(value);
    }
  };

  const ShowWarning = ({ workorderItem }: CellProps) => {
    return (
      <td>
        <Typography variant="body1" style={{ cursor: 'pointer' }}>
          {/* {bundleService?.bundlePrice !== 0 && `$${bundleService?.bundlePrice}`} */}

          {workorderItem?.pendingRules?.length > 0 ? (
            <Tooltip
              title={
                <Typography variant="body1">
                  {' '}
                  {workorderItem?.pendingRules?.map((errorRule: any, index: number) => <p key={index}>{errorRule}</p>)}
                </Typography>
              }
            >
              <ReportIcon style={{ color: 'orange' }} />
            </Tooltip>
          ) : (
            ''
          )}
        </Typography>
      </td>
    );
  };

  const ShowPropsedSheduleDate = ({ workorderItem }: CellProps) => {
    // Compare only the date (not time)

    return (
      <td>
        {!!workorderItem?.proposedScheduledDate && (
          <Typography variant="body1">
            <span style={{ color: workorderItem?.isPastProposedScheduledDate ? 'red' : 'black' }}>
              {workorderItem?.proposedScheduledDate}
            </span>
            <GuardedComponent requiredPermissions={[UserPermissionName.BULKSCHEDULE_INSPECTIONS]}>
              <IconButton aria-label="move" onClick={() => handleCalenderButtonClick(workorderItem?.workOrderID, workorderItem?.proposedScheduledDate)}>
                <Tooltip title={<Typography variant="body1">Change proposed schedule date</Typography>}>
                  <img style={{ width: 12 }} src={Icons.IconCalendar} alt="change proposed schedule date" />
                </Tooltip>
              </IconButton>
            </GuardedComponent>
          </Typography>
        )}
      </td>
    );
  };

  const ShowSheduleDate = ({ workorderItem }: CellProps) => {
    // Compare only the date (not time)
    const isScheduledDate = workorderItem?.scheduledDate
      ? dayjs(workorderItem.scheduledDate).isBefore(dayjs().startOf('day'))
      : false;
    return (
      <td>
        {!!workorderItem?.scheduledDate && (
          <Typography variant="body1">
            <span style={{ color: isScheduledDate ? 'red' : 'black' }}>{workorderItem?.scheduledDate}</span>
          </Typography>
        )}
      </td>
    );
  };

  const ShowRequestedRescheduledDate = ({ workorderItem }: CellProps) => {
    // Compare only the date (not time)
    const isRequestedRescheduledDate = workorderItem?.requestedRescheduledDate
      ? dayjs(workorderItem.requestedRescheduledDate).isBefore(dayjs().startOf('day'))
      : false;
    return (
      <td>
        {!!workorderItem?.requestedRescheduledDate && (
          <Typography variant="body1">
            <span style={{ color: isRequestedRescheduledDate ? 'red' : 'black' }}>
              {workorderItem?.requestedRescheduledDate}
            </span>
          </Typography>
        )}
      </td>
    );
  };

  const JobsiteCell = ({ workorderItem }: CellProps) => {
    const [isHovered, setIsHovered] = useState(false);
    const handleClickJobsite = () => {
      window.open(`/units/profile/${workorderItem?.unitID}`, '_blank');
    };
    return (
      <td style={{ cursor: 'pointer' }} onClick={handleClickJobsite}>
        <Typography
          component="span"
          style={{
            color: isHovered ? '#0000b5' : '#0000b5',
            textDecoration: isHovered ? 'underline' : 'none',
            cursor: 'pointer',
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {workorderItem?.jobsite}
        </Typography>
      </td>
    );
  };

  const CustomGridCell = ({ field }: CustomGridCellProps): ((dataItem: any) => JSX.Element) | undefined => {
    if (field === 'warning') {
      // Return a function that takes a data item and returns a JSX element
      return (dataItem: any) => {
        return <ShowWarning workorderItem={dataItem.dataItem} />;
      };
    }
    if (field === 'proposedScheduledDate') {
      return (dataItem: any) => {
        return <ShowPropsedSheduleDate workorderItem={dataItem.dataItem} />;
      };
    }
    if (field === 'scheduledDate') {
      return (dataItem: any) => {
        return <ShowSheduleDate workorderItem={dataItem.dataItem} />;
      };
    }
    if (field === 'requestedRescheduledDate') {
      return (dataItem: any) => {
        return <ShowRequestedRescheduledDate workorderItem={dataItem.dataItem} />;
      };
    }
    if (field === 'matchPercentage') {
      return (dataItem: any) => {
        return <td>{dataItem?.dataItem?.matchPercentage?.toFixed(2)}%</td>;
      };
    }
    // if (field === 'workOrderNumber' && selectedInspector?.length > 0) {
    //   return (dataItem: any) => {
    //     const getColor = (value: number) => {
    //       if (value >= 100) return 'green';
    //       if (value >= 50 && value < 80) return 'yellow';
    //       if (value >= 30 && value < 50) return 'orange';
    //       return 'red';
    //     };
    //     const progress = dataItem?.dataItem?.matchPercentage || 0;
    //     const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    //       '& .MuiBadge-badge': {
    //         // right: -20,
    //         // top: 10,
    //         border: `2px solid ${theme.palette.background.paper}`,
    //         padding: '0 4px',
    //         backgroundColor: getColor(progress),
    //         minWidth: 16,
    //         minHeight: 16,
    //         height: 16,
    //       },
    //     }));
    //     return (
    //       <td>
    //         <StyledBadge badgeContent={''} color="default"></StyledBadge>
    //         <span style={{ paddingLeft: 18 }}>{dataItem?.dataItem?.workOrderNumber}</span>
    //       </td>
    //     );
    //   };
    // }
    if (field === 'jobsite') {
      // Return a function that takes a data item and returns a JSX element
      return (dataItem: any) => {
        return <JobsiteCell workorderItem={dataItem.dataItem} />;
      };
    }
    return undefined;
  };

  const conditionalCellRender = (
    defaultRendering: React.ReactElement<HTMLTableCellElement> | null,
    props: GridCellProps
  ) => {
    // if (props.field === 'selected' && selectedInspector?.length > 0 && props?.dataItem?.matchPercentage !== 100) {
    //   return (
    //     <Tooltip title={<Typography variant="body1">Inspection criteria does not match with the inspector</Typography>}>
    //       <td>
    //         <Checkbox disabled={props?.dataItem?.matchPercentage !== 100} />
    //       </td>
    //     </Tooltip>
    //   );
    // } else
    {
      return defaultRendering;
    }
  };

  const handleCalenderButtonClick = (WoId: number, scheduleDate: any) => {
    setCurrentWorkOrderID(WoId);
    setValue('proposedSheduleDate', scheduleDate);
    setOpenDialog(true);
  };

  const closeDialog = () => {
    setOpenDialog(false);
    setValue('proposedSheduleDate', undefined);
    setCurrentWorkOrderID(0);
  };

  const [pendingRuleResponse, setPendingErrorRoles] = useState<any>();
  const [openRuleDialog, setRuleDialog] = useState<boolean>(false);

  const ishavePermission = useAuthorize([UserPermissionName?.OVERRIDE]);

  const { showSnackbar } = useSnackbar();

  const isHolidayOrWeekend = (scheduleDate: any, holidayDates: any) => {
    const selectedDate = dayjs(scheduleDate, "MM/DD/YYYY");

    // Check weekend
    const day = selectedDate.day(); // 0 = Sunday, 6 = Saturday
    const isWeekend = day === 0 || day === 6;

    // Check holiday
    const isHoliday = holidayDates?.some((holiday: any) =>
      dayjs(holiday.date, "MM/DD/YYYY").isSame(selectedDate, "day")
    );

    return {
      isWeekend,
      isHoliday,
      isInvalid: isWeekend || isHoliday,
    };
  };

  const handleSumbitConfirm = async () => {

    const result = isHolidayOrWeekend(dayjs(getValues('proposedSheduleDate'))?.format('MM/DD/YYYY'), holidayDates);

    if (result?.isHoliday && shouldRestrictDateSelection) {
      showSnackbar(
        'The selected proposed schedule date falls on a holiday. Please choose a valid working day to proceed.',
        'error'
      );
      return;
    }
    if (result?.isWeekend && shouldRestrictDateSelection) {
      showSnackbar(
        'The selected proposed schedule date falls on a weekend. Please choose a valid working day to proceed.',
        'error'
      );
      return;
    }


    const rulePayload = {
      workOrderID: currentWorkOrderID,
      proposedScheduleDate: dayjs(getValues('proposedSheduleDate'))?.format('MM/DD/YYYY')
    }
    const ruleResponse: any = await mutatePrerequisitesAsync({ data: rulePayload });

    const hasPendingRule = ruleResponse?.data?.pendingRules?.length;
    if (hasPendingRule > 0) {
      setPendingErrorRoles(ruleResponse?.data)
      setRuleDialog(true);
    }
    else {
      updateProposedSheduleDate({
        data: {
          workOrderID: currentWorkOrderID,
          proposedScheduledDate: getValues('proposedSheduleDate'),
        },
      }).then((data: any) => {
        handleFilterClick();
        closeDialog();
      });
    }
  };

  const closeValidationDialog = () => {
    setRuleDialog(false);
    setPendingErrorRoles(undefined);
  }

  const handleSumbitRuleConfirm = () => {
    closeValidationDialog();
    updateProposedSheduleDate({
      data: {
        workOrderID: currentWorkOrderID,
        proposedScheduledDate: getValues('proposedSheduleDate'),
      },
    }).then((data: any) => {
      handleFilterClick();
      closeDialog();
    });
  }

  // -------------------------------------
  const [updatedWorkorderData, setUpdatedWorkorderData] = useState<any[]>([]);

  // Utility function to calculate match percentage

  //const calculateMatchPercentage = (selectedSkills: string[], workOrdersSkills: string[]): number => {
  //  const matchingSkills = workOrdersSkills?.filter((skill) => selectedSkills?.includes(skill));

  //  if (matchingSkills?.length && selectedSkills?.length) {
  //    return (matchingSkills?.length / selectedSkills?.length) * 100;
  //  }
  //  return 0;
  //  };
  //  const calculateMatchPercentageskill = (
  //      selectedSkills: string[],
  //      workOrdersSkills: string[],
  //      workOrderID: number
  //  ): number => {
  //      const matchingSkills = workOrdersSkills?.filter((skill) => selectedSkills?.includes(skill));

  //      if (matchingSkills?.length && selectedSkills?.length) {
  //          return (matchingSkills?.length / selectedSkills?.length) * 100;
  //      }
  //      return 0;
  //  };
  const calculateMatchPercentageskill = (
    selectedSkills: string[],
    workOrdersSkills: string[],
    workOrderID: number
  ): number => {

    const cleanedSelectedSkills = (selectedSkills || []).filter(
      (id) => id !== "" && id !== null && id !== undefined
    );

    const cleanedWorkOrderSkills = (workOrdersSkills || []).filter(
      (id) => id !== "" && id !== null && id !== undefined
    );

    // If work order has no skills → return 100%
    if (cleanedWorkOrderSkills.length === 0) {
      return 100;
    }

    const matchingSkills = cleanedWorkOrderSkills.filter(skill =>
      cleanedSelectedSkills.includes(skill)
    );

    // Percentage based on total work order skills
    return (matchingSkills.length / cleanedWorkOrderSkills.length) * 100;
  };

  // Effect to recalculate inspector data based on selected workorder changes
  useEffect(() => {
    if (data?.data) {
      // Collect unique skill IDs from selectedWorkorder
      const selectedInspectorsSkills = Array.from(
        new Set(
          selectedInspector
            ?.flatMap((inspector: any) => inspector?.userSkillSetIDList?.split(','))
            ?.map((skill) => skill?.trim())
        )
      );

      const selectedInspectorsEquipment = Array.from(
        new Set(
          selectedInspector
            ?.flatMap((inspector: any) => inspector?.userEquipmentIDList?.split(','))
            ?.map((skill) => skill?.trim())
        )
      );

      const recalculatedWorkorderData = data?.data?.map((workOrder: any) => {
        return {
          ...workOrder,
          // isSelected: selectedWorkorder?.some((s) => s.workOrderID === workOrder.workOrderID),
          selected: selectedWorkorder?.some((s) => s.workOrderID === workOrder.workOrderID),
          matchPercentage:
            calculateMatchPercentageskill(
              selectedInspectorsSkills,
              workOrder.serviceSkillSetIDList?.split(',')?.map((skill: any) => skill?.trim()),
              workOrder?.workOrderID
            )
          // (calculateMatchPercentageskill(
          //   selectedInspectorsSkills,

          //   workOrder.serviceSkillSetIDList?.split(',')?.map((skill: any) => skill?.trim()),
          //   workOrder?.workOrderID
          // ) +
          //   calculateMatchPercentageskill(
          //     selectedInspectorsEquipment,

          //     workOrder.serviceEquipmentIDList?.split(',')?.map((skill: any) => skill?.trim()),
          //     workOrder?.workOrderID
          //   )) /
          // 2,
        };
      });

      // Update inspector data with recalculated match percentages
      setUpdatedWorkorderData(recalculatedWorkorderData);
    }
  }, [selectedInspector, selectedWorkorder, data]);

  // ----------------------------

  // const rowRender = (row: React.ReactElement, rowProps: GridRowProps) => {
  //   const trElement = React.cloneElement(row, {
  //     style: { backgroundColor: rowProps.dataItem?.matchPercentage === 100 ? '#5ae385' : '#rgb(255 255 255)' },
  //     // onClick: () => handleRowClick(rowProps.dataItem as any),
  //   });
  //   return trElement;
  // };

  // const rowRender = (row: React.ReactElement, rowProps: GridRowProps) => {
  //   const isMatched = rowProps.dataItem?.matchPercentage === 100;
  //   const backgroundColor = isMatched ? '#5ae385' : 'rgb(255 255 255)'; // Green for 100%, Red otherwise
  //   const trElement = React.cloneElement(row, {
  //     style: { backgroundColor: backgroundColor },
  //   });
  //   return trElement;
  // };

  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout,
  } = useLoadData<ApiResponse<GridPreference>>(
    gridApiKeyStore.getGridLayout('BulkScheduleInspection', 'BulkScheduleInspection')
  );

  const { mutateAsync: mutateInspectionAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();



  const [filteredInspections, setFilteredInspections] = useState<any[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredInspectionList = updatedWorkorderData?.filter((Inspection) =>
      Object.values(Inspection).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredInspections(filteredInspectionList || []);
  }, [debouncedSearchTerm, updatedWorkorderData]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'BulkScheduleInspection',
      pageName: 'BulkScheduleInspection',
    };

    mutateInspectionAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'BulkScheduleInspection',
      pageName: 'BulkScheduleInspection',
    };

    mutateInspectionAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };



  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);

  // ----------------------------------------------------------------------------------------
  // save filter layout--------------------------------------------------
  const { data: savedFilterData, refetch: refetchSavedFilterData } = useLoadData<ApiResponse<GridPreference>>(
    gridApiKeyStore.getGridLayout('BulkScheduleFilterSave', 'BulkScheduleFilterSave')
  );
  const { mutateAsync: mutateSaveBulkFilters } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());

  useEffect(() => {
    if (!savedFilterData?.data) return;

    try {
      const filterData = savedFilterData.data.filterJSON ? JSON.parse(savedFilterData.data.filterJSON) : null;
      setValue('marketAreaIDs', !filterData?.marketArea ? [] : filterData?.marketArea);
      setValue('divisions', !filterData?.divisions ? [] : filterData?.divisions);
      setValue('fromDate', !filterData?.fromDate ? '' : filterData?.fromDate);
      setValue('toDate', !filterData?.toDate ? '' : filterData?.toDate);
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [savedFilterData?.data]);

  const handleSaveFilter = () => {
    const filterValues = {
      marketArea: getValues('marketAreaIDs'),
      fromDate: getValues('fromDate'),
      toDate: getValues('toDate'),
      divisions: getValues('divisions'),
    };

    const data = {
      filterJSON: JSON.stringify(filterValues),
      columnJSON: '',
      gridName: 'BulkScheduleFilterSave',
      pageName: 'BulkScheduleFilterSave',
    };
    mutateSaveBulkFilters({ data }).then(() => {
      refetchSavedFilterData();
    });
  };
  // -----------------------------

  const [holidayDates, setHolidayDates] = useState<any[]>([]);
  const { isLoading: isHolidayLoading, data: holidayData } = useLoadData<ApiResponse<any[]>>(
    holidayManagementApiKeyStore.getHolidays());

  useEffect(() => {
    if (holidayData) {
      const datesResult = holidayData?.data
        .filter((item: any) => item.isActive)
        //?.map((item: any) => item.holidayDate);
        ?.map((item: any) => ({
          date: item.holidayDate,
          name: item.holidayName,
        }));
      setHolidayDates(datesResult);
    }
  }, [holidayData])

  //const isWeekendHolidaySchedulingOverridePermission = !useAuthorize([UserPermissionName?.WEEKEND_HOLIDAY_SCHEDULING_OVERRIDE]);

  const hasWeekendHolidayOverridePermission = useAuthorize([
    UserPermissionName.WEEKEND_HOLIDAY_SCHEDULING_OVERRIDE,
  ]);

  const shouldRestrictDateSelection = !hasWeekendHolidayOverridePermission;

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);


  const scheduleWorkOrderGridColumns = useMemo(() => {
    if (gridConfig?.columns) {
      return gridConfig.columns
    }
    return workOrderColumns?.filter((column) => column?.field !== 'matchPercentage')
  }, [gridConfig, workOrderColumns])



  return (
    <>
      <Grid container spacing={1}>
        <Grid container spacing={1}>
          <Grid item lg={3} sm={6} xl={3} xs={6}>
            <FormAutoCompleteSelectDynamic
              name="customer"
              label="Customer"
              getQueryKeyConfig={() => customersApiKeyStore.getCustomers()}
              optionsValueKey="customerID"
              optionsLabelKey="customerName"
              onChange={(value: any) => handleOnChange('customer', value)}
            />
          </Grid>
          <Grid item lg={3} sm={6} xl={3} xs={6}>
            <FormAutoCompleteMultiSelectDynamic
              name="officeIDs"
              label="Offices"
              watchKeys={['customer']}
              getQueryKeyConfig={(inputData: any) =>
                officeApiKeyStore.getCustomerOffices(inputData.customer?.customerID)
              }
              optionsLabelKey="officeName"
              optionsValueKey="officeID"
              disabled={!customerID}
              onChange={
                (values: any) => handleOnChange('office', values)
                // setOfficeIDs(values)
              }
            />
          </Grid>
          <Grid item lg={3} sm={6} xl={3} xs={6}>
            <FormAutoCompleteMultiSelectDynamic
              name="projectIDs"
              label="Projects"
              watchKeys={['officeIDs']}
              getQueryKeyConfig={(inputData: any) =>
                projectsApiKeyStore.getOfficesProjects(inputData.officeIDs?.map((o: any) => o.officeID))
              }
              optionsLabelKey="projectName"
              optionsValueKey="projectID"
              disabled={!officeIDs || officeIDs?.length === 0}
              onChange={
                (values: any) => handleOnChange('project', values)
                //  setProjectIDs(values)
              }
            />
          </Grid>
          <Grid item lg={3} sm={6} xl={3} xs={6}>
            <FormAutoCompleteMultiSelectDynamic
              name="marketAreaIDs"
              label="Market Areas"
              getQueryKeyConfig={() => marketAreaApiKeyStore.getMarketAreas()}
              optionsLabelKey="marketAreaName"
              optionsValueKey="marketAreaID"
              onChange={(values: any) => setMarketAreaIDs(values)}
            />
          </Grid>
          <Grid item lg={3} sm={6} xl={3} xs={6}>
            <FormAutoCompleteMultiSelectDynamic
              name="userIDs"
              label="Inspectors"
              getQueryKeyConfig={() => usersApiKeyStore.getUsersByRole('ins')}
              optionsLabelKey="fullName"
              optionsValueKey="userID"
              onChange={(values: any) => setUserIDs(values)}
            />
          </Grid>
          <Grid item lg={3} sm={6} xl={3} xs={6}>
            {/* <FormAutoCompleteMultiSelectDynamic
              name="workOrderStatusIDs"
              label="Status"
              getQueryKeyConfig={() => workOrdersApiKeyStore.getWorkOrderStatus('BulkscheduleInspectionListFilter')}
              optionsLabelKey="workOrderStatus"
              optionsValueKey="workOrderStatusID"
              onChange={(values: any) => setWorkOrderStatusIDs(values)}
            /> */}
            <FormAutoCompleteSelectDynamic
              name="workOrderStatusID"
              label="Status"
              getQueryKeyConfig={() => workOrdersApiKeyStore.getWorkOrderStatus('BulkscheduleInspectionListFilter')}
              optionsValueKey="workOrderStatusID"
              optionsLabelKey="workOrderStatus"
              onChange={(value: any) => setWorkOrderStatusIDs(value?.workOrderStatusID)}
              clearIcon={false}
            />
          </Grid>
          <Grid item lg={2} sm={4} xl={2} xs={6}>
            <FormDateField label="From" name="fromDate" format={DateFormat.SIMPLE_DATE} />
          </Grid>
          <Grid item lg={2} sm={4} xl={2} xs={6}>
            <FormDateField label="To" name="toDate" format={DateFormat.SIMPLE_DATE} />
          </Grid>
          <Grid item lg={3} sm={6} xl={3} xs={6}>
            <FormAutoCompleteMultiSelectDynamic
              name="departments"
              label="Departments"
              getQueryKeyConfig={() => departmentsApiKeyStore.getDepartmentsWithManager()}
              optionsLabelKey="departmentName"
              optionsValueKey="departmentID"
              onChange={(values: any) => setDepartments(values)}
            />
          </Grid>
          <Grid item lg={3} sm={6} xl={3} xs={6}>
            <FormAutoCompleteMultiSelectDynamic
              name="divisions"
              label="Divisions"
              getQueryKeyConfig={() => divisionApiKeyStore.getDivisions()}
              optionsLabelKey="divisionName"
              optionsValueKey="divisionID"
              onChange={(values: any) => setDivisionIDs(values)}
            />
          </Grid>
          <Grid item lg={2} sm={4} xl={2} xs={6}>
            <Button
              type="button"
              onClick={handleFilterClick}
              title="Filter"
              className="btn btn-primary "
              style={{ lineHeight: 1.6 }}
            >
              Filter
            </Button>
          </Grid>
          <Grid item lg={12} sm={12} xl={12} xs={12} style={{ padding: '8px', paddingRight: '0' }}>
            <div
              style={{
                padding: '16px',
                background: '#fff',
                borderRadius: '8px',
              }}
            >
              <div
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}
              >
                <h3 style={{ display: 'flex', alignItems: 'center' }}>INSPECTION LIST</h3>{' '}
              </div>

              <SiTrackGrid
                fileTitle='schedule_workorder'
                // columns={workOrderColumns}
                columns={
                  scheduleWorkOrderGridColumns
                  // selectedWorkorder?.length > 0
                  //   ? selectedInspector?.length > 0
                  //     ? workOrderColumns
                  //     : workOrderColumns?.filter((column) => column?.field !== 'matchPercentage')
                  //   : selectedInspector?.length > 0
                  //     ? workOrderColumns?.filter((column) => column?.field !== 'warning')
                  //     : workOrderColumns?.filter((column) => column?.field !== 'matchPercentage')
                }
                dataItemKey="workOrderID"
                selectedField="selected"
                onSelectedItems={handleSelectedWorkOrders}
                preventCheckAndUnCheckOnHeaderelectionChange={
                  selectedInspector?.length > 0 ? ['workOrderID'] : undefined
                }
                // dataItems={data?.data}
                isBusy={isLoading || isLoadingGridLayout}
                conditionalCellRender={conditionalCellRender}
                customCell={(field) =>
                  CustomGridCell({
                    field,
                  })
                }
                actionPermissions={{
                  export: UserPermissionName.DOWNLOAD_GRID,
                }}
                // rowRender={rowRender}

                // selectionMode="single"

                // -----------------Grid Layout-------
                dataItems={filteredInspections || []}
                reorderable
                handleSearch={handleInputChange}
                handleSaveLayout={handleSaveLayout}
                isSaveLayout={true}
                gridConfigFromApi={gridConfig}
                handleResetLayout={handleResetLayout}
              // -----------------Grid Layout-------
              />
            </div>
          </Grid>
        </Grid>
      </Grid>

      {openDialog && (
        <Dialog
          open={openDialog}
          fullWidth={true}
          maxWidth={'sm'}
        // onClose={onClosed}
        >
          <DialogTitle id="scroll-dialog-title">Proposed Schedule Date</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={closeDialog}
            sx={{
              position: 'absolute',
              right: 10,
              top: 15,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Tooltip title={<Typography variant="body1">Close</Typography>}>
              <CloseIcon />
            </Tooltip>
          </IconButton>
          {/* <ReactHookForm formName="PROJECT_FORM" onSubmit={handleSubmit} formContextProps={form}> */}
          {isLoadingProposedSheduleDate && <LoadingIndicator isLoading={isLoadingProposedSheduleDate} />}
          <DialogContent dividers className="popupDilog">
            <Grid container spacing={2}>
              <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormDateField
                  label="Proposed Schedule Date"
                  name="proposedSheduleDate"
                  dateLimits={{ minDateEnabled: true }}
                  format={DateFormat.SIMPLE_DATE}
                  //restrictDateSelection={isWeekendHolidaySchedulingOverridePermission}
                  //holidayDateList={isWeekendHolidaySchedulingOverridePermission ? holidayDates : []}
                  restrictDateSelection={shouldRestrictDateSelection}
                  holidayDateList={holidayDates}
                  enableDateConfirmation={hasWeekendHolidayOverridePermission}
                  isParentLoading={isHolidayLoading}
                  disabled={isHolidayLoading}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
            <DialogActions className="spaceBetween">
              {/* <Button
                // variant="outlined"
                style={{ width: '130px' }}
                className={`btn btn-sm  `}
                onClick={closeDialog}
              >
                Cancel
              </Button> */}
              <Button
                type="button"
                variant='contained'
                // className={`btn btn-sm ${!getValues('proposedSheduleDate') ? '' : 'btn-primary'}`}
                style={{ width: '100px', marginLeft: 'auto' }}
                onClick={handleSumbitConfirm}
                disabled={!getValues('proposedSheduleDate') || isLoadingProposedSheduleDate || isPrerequisitesLoading || isReadOnlyPermission}
              >
                Save
              </Button>
            </DialogActions>
          </div>
          {/* </ReactHookForm> */}
        </Dialog>
      )}

      {openRuleDialog && (
        <Dialog
          open={openRuleDialog}
          className="modalpopup"
          title={'CONFIRM STATUS'}
        // onClose={closeDialog}
        >
          <div>
            <div style={{ padding: '25px 50px' }}>
              <div>
                <h4>Please see the below validation</h4>
                <br></br>
                <ul>
                  {pendingRuleResponse?.pendingRules?.map((rules: any) => (
                    <div key={`${pendingRuleResponse?.workorderID}-${rules}`}>
                      {/* <li style={{ marginLeft: '25px' }}> */}
                      <span>{rules}</span>
                      {/* </li> */}
                      {rules.includes("pre-requisite") && pendingRuleResponse?.preReqWorkOrders?.length > 0 && (
                        <dl>
                          <dt>Pending Work Orders:</dt>
                          {pendingRuleResponse?.preReqWorkOrders?.map((data: any) => <dd key={data}>- {data}</dd>)}
                        </dl>
                      )}
                    </div>
                  ))}
                </ul>
              </div>
              <br></br>
              <div>
                {ishavePermission ? (
                  <h5>
                    You have permission to change the proposed schedule date without completing the validation.
                    Are you sure you want to
                    continue?
                  </h5>
                ) : (
                  <h5>You can not change the proposed schedule date without completing the validation.</h5>
                )}
              </div>
              <LoadingIndicator isLoading={isLoading} />
            </div>
          </div>
          <DialogActionsBar>
            <div className=" spaceBetween">
              <button
                style={{ cursor: 'pointer' }}
                className="btn btn-sm btn-default btn-lightGrey"
                onClick={closeValidationDialog}
                autoFocus
              >
                Cancel
              </button>
              {ishavePermission && (
                <button
                  className="btn btn-sm btn-primary  btn-delete"
                  type="button"
                  onClick={handleSumbitRuleConfirm}
                  disabled={isLoading}
                  style={{ cursor: 'pointer' }}
                >
                  Confirm
                </button>
              )}
            </div>
          </DialogActionsBar>
        </Dialog>
      )}

      {/* {openDialog && (
        <Dialog
          open={openDialog}
          className="modalpopup"
          title={'proposed scheduled date '}
          // onClose={closeDialog}
        >
          <DialogTitle id="dialog-title"> </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={closeDialog}
            sx={{
              position: 'absolute',
              right: 10,
              top: 3,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Tooltip title={<Typography variant="body1">Close</Typography>}>
              <CloseIcon />
            </Tooltip>
          </IconButton>
          {isLoadingProposedSheduleDate && <LoadingIndicator isLoading={isLoadingProposedSheduleDate} />}
          <DialogContent dividers style={styling.contentPadding} className="popupDilog">
            <FormDateField label="Proposed Schedule Date" name="proposedSheduleDate" format={DateFormat.SIMPLE_DATE} />
          </DialogContent>
          
          <div
            style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px', marginLeft: 'auto', cursor: 'pointer' }}
          >
            <DialogActions className="spaceBetween">
              <Button
                className={`btn btn-sm ${!getValues('proposedSheduleDate') ? '' : 'btn-primary'}`}
                type="button"
                onClick={handleSumbitConfirm}
                disabled={!getValues('proposedSheduleDate') || isLoadingProposedSheduleDate}
                style={{ cursor: 'pointer' }}
              >
                Save
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      )} */}
    </>
  );
});
